import type { ModuleFactory, ModuleManifest } from "./contracts/module";

/** Identidade tipada — autocomplete e checagem ao escrever o manifesto. */
export function defineManifest(manifest: ModuleManifest): ModuleManifest {
  return manifest;
}

/** Identidade tipada para a factory do módulo. */
export function defineModule(factory: ModuleFactory): ModuleFactory {
  return factory;
}
